var 
	Legislacao,
	$body,
	$window
;

(function($){

	Legislacao = {

		$ : null,

		body : function(){
			return $body;
		},

		window : function(){
			return $window;
		},

		init : function(){

			$body = $( 'body' );
			$window = $( 'window' );

			this.$ = $( '#filtros-legislacao' );
			if( !this.$.length ) return true;

			this.$termo = $( 'input[name="termo"]', this.$ );
			this.$tipos = $( 'input[name="tipo"]', this.$ );

			// Tipos marcados
			this.$tipos.on( 'change', function(){
				Legislacao.$.submit();
			});

			// Actual
			const $actual = this.$tipos.filter( ':checked' );
			if( $actual.length ){
				$actual.parent( 'label' ).on( 'click', function(){
					$actual.prop( 'checked', false );
					Legislacao.$.submit();
				});
			}

			// Remove empty query strings
			this.$.on( 'submit', function(){
			
				if( Legislacao.$termo.val() === '' ){
					Legislacao.$termo.removeAttr( 'name' );
				}

				if( !Legislacao.$tipos.filter( ':checked' ).length ){
					Legislacao.$tipos.removeAttr( 'name' );
				}
			
				return true;
			
			});

		}
		
	}
	$(function(){
		Legislacao.init();
	});

})(jQuery);
